// extracted by mini-css-extract-plugin
export default {"infoWrapper":"GamePlayerInfoContainer_infoWrapper__QAVvR"};